/**
 * --- KONSEP: EKOR DATABASE (SUPABASE) ---
 * File ini adalah "kabel penghubung" utama antara aplikasi (Frontend)
 * dengan pusat data kita di Supabase. Tanpa ini, aplikasi tidak bisa
 * menyimpan atau mengambil barang.
 */
import { createClient } from "@supabase/supabase-js";

// Alamat dan Kunci Rahasia untuk masuk ke Database
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL || "https://placeholder.supabase.co";
const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY || "placeholder";

if (supabaseUrl === "https://placeholder.supabase.co") {
  console.warn(
    "PERINGATAN: Kredensial Supabase belum diatur! Cek file .env Anda.",
  );
}

// Membuat "Klien" yang akan digunakan di seluruh aplikasi untuk panggil data
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
